import {CartForTransaction} from "../../components/forms/F005OrderForm/formUtils";

type WindowWithDataLayer = Window & {
    dataLayer: Record<string, any>[]
}
class OrderItem {
    item_name: string;
    item_id: string;
    price: string;
    item_category: string;
    quantity: string;
    constructor(item_name: string, item_id: string, price: number, item_category: string, quantity: number) {
        this.item_name = item_name;
        this.item_id = item_id;
        this.price = price.toString();
        this.item_category = item_category;
        this.quantity = quantity.toString();
    }
}
function stringify(value: any) {
    if (value) {
        return (typeof value === 'string' || value instanceof String) ? value : value.toString();
    } else {
        return '';
    }
}
function getItemName(sponsorshipType: number|undefined, donationType: number|undefined) {
    let itemName =  'donation';
    if (donationType && donationType === 2) {
        return 'giftshop';
    }
    if (sponsorshipType) {
        if (sponsorshipType === 3) {
            itemName = 'childSponsorship';
        }
        if (sponsorshipType === 4) {
            itemName = 'villageSponsorGermany';
        }
        if (sponsorshipType === 5) {
            itemName = 'villageSponsorAbroad';
        }
    }
    return itemName;
}

declare const window: WindowWithDataLayer

const waitForDataLayer = () => {
    return new Promise<void>((resolve) => {
        const interval = setInterval(() => {
            if (typeof window.dataLayer !== "undefined") {
                clearInterval(interval);
                resolve();
            }
        }, 100);
    });
};

export const pageview = async (url: string, campaignId: null|string, channelId: null|string) => {
    await waitForDataLayer();
    window.dataLayer.push({
        event: 'gaEvent',
        event_name: 'page_view',
        page: url,
        campaign_id: campaignId || null,
        channel_id: channelId || null
    });
};

export const transaction = (transcationId: string, campaignId: null|string, channelId: null|string, transactionData: any|null) => {
    const campaign = campaignId ? campaignId : null;
    const channel = channelId ? channelId : null;
    const sponsorshipType = transactionData!.sponsorshipType;
    let donationRhythm = transactionData!.donationRhythm;
    let donationType = transactionData!.donationType;
    let itemName =  getItemName(sponsorshipType, donationType);
    let quantity = transactionData!.quantity;

    if (sponsorshipType && sponsorshipType > 1) {
        donationRhythm = 1;
    }
    if (!donationRhythm) {
        donationRhythm = 0;
    }
    const itemId = transactionData!.itemId ?  transactionData.itemId : itemName + "." + donationRhythm;
    const donatorType = transactionData!.donatorType;
    const gift = transactionData!.gift;
    const newsletter = transactionData!.newsletter;
    const paymentMethod = transactionData!.paymentMethod;
    const amount = transactionData!.amount;
    const priority = transactionData!.priority;
    if (typeof window.dataLayer !== "undefined") {
        console.log("transaction datalayer push: " + transcationId);
        window.dataLayer.push({
            event: 'gaEvent',
            campaign_id: stringify(campaign),
            channel_id: stringify(channel),
            event_name: 'purchase',
            transaction_frequency: stringify(donationRhythm),
            transaction_donortype: stringify(donatorType),
            transaction_gift: stringify(gift),
            transaction_newsletter: stringify(newsletter),
            transaction_payment_method: stringify(paymentMethod),
            ecommerce: {
                transaction_id: stringify(transcationId),
                affiliation: 'https://www.sos-kinderdorf.de',
                value: stringify(amount),
                currency: 'EUR',
                items: [{
                    item_name: stringify(itemName),
                    item_list_name: stringify(priority),
                    item_id: stringify(itemId),
                    price: stringify(amount),
                    quantity: stringify(quantity)
                }]}});
    } else {
        console.log("transaction datalayer not pushed!")
        console.log({
            event: 'gaEvent',
            campaign_id: stringify(campaign),
            channel_id: stringify(channel),
            event_name: 'purchase',
            transaction_frequency: stringify(donationRhythm),
            transaction_donortype: stringify(donatorType),
            transaction_gift: stringify(gift),
            transaction_newsletter: stringify(newsletter),
            transaction_payment_method: stringify(paymentMethod),
            ecommerce: {
                transaction_id: stringify(transcationId),
                affiliation: 'https://www.sos-kinderdorf.de',
                value: stringify(amount),
                currency: 'EUR',
                items: [{
                    item_name: stringify(itemName),
                    item_list_name: stringify(priority),
                    item_id: stringify(itemId),
                    price: stringify(amount),
                    quantity: stringify(quantity)
                }]}})
    }
}
export const orderTransaction = (transcationId: string, transactionData: CartForTransaction|null) => {
    const sumTotal = transactionData ? transactionData?.sumTotal : 0;
    const items = transactionData ? transactionData?.items : [];
    const newsletter = transactionData ? transactionData?.newsletter : false;
    let orderItems: OrderItem[] = [];
    items.forEach(item => {
        orderItems.push(new OrderItem(item.title, item.publicationId, item.price, 'Publikation', item.quantity));
    });
    if (typeof window.dataLayer !== "undefined") {
        console.log("orderTransaction datalayer push: " + transcationId);
        window.dataLayer.push({
            event: 'gaEvent',
            event_name: 'purchase',
            transaction_newsletter: stringify(newsletter),
            ecommerce: {
                transaction_id: stringify(transcationId),
                affiliation: 'https://www.sos-kinderdorf.de',
                value: stringify(sumTotal),
                currency: 'EUR',
                items: orderItems
            }
        })
    } else {
        console.log("orderTransaction datalayer not pushed!")
        console.log({
            event: 'gaEvent',
            event_name: 'purchase',
            transaction_newsletter: false,
            ecommerce: {
                transaction_id: transcationId,
                affiliation: '',
                value: sumTotal,
                currency: 'EUR',
                items: JSON.stringify(orderItems)
            }
        })
    }
}
